import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/SearchAlertEvents.ts';

export type SaveSearchTriggerLocation = 'search_results_list' | 'search_results_map' | 'search_results_feed';

const CREATE_SEARCH_ALERT = defineHotpadsEvent({
  key: 'search_alert.create',
  eventTypeId: '5834',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackCreateSearchAlertEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'button_to_create_search_alert',
    object: 'search_results|alerts_modal',
  },
  semanticEvent: 'create_search_alert',
});

const POST_CONTACT_POPUP_VIEW = defineHotpadsEvent({
  key: 'search_alert.post_contact_popup_view',
  eventTypeId: '5930',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackPostContactPopupViewEvent',
  trigger: {
    type: 'view',
    location: 'post_contact_popup',
    source: 'post_contact_popup',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

// Event 5832 v2 registers SRP surfaces as trigger locations. Its registered
// trigger object remains filter_panel; changing that would invalidate the event.
const OPEN_SEARCH_ALERT_MODAL = defineHotpadsEvent({
  key: 'search_alert.open_modal',
  eventTypeId: '5832',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackOpenSearchAlertModalEvent',
  trigger: {
    type: 'interaction',
    location: 'search_results',
    source: 'button_to_open_search_alert_modal',
    object: 'filter_panel',
  },
  semanticEvent: 'open_search_alert_modal',
});

export function emitTrackCreateSearchAlertEvent({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: 'post_contact_popup' | 'search_results';
  triggerObject: 'post_contact_popup|alerts_modal' | 'search_results|alerts_modal';
}) {
  trackHotpadsEventDefinition(CREATE_SEARCH_ALERT, { triggerLocation, triggerObject });
}

export function emitTrackPostContactPopupViewEvent() {
  trackHotpadsEventDefinition(POST_CONTACT_POPUP_VIEW);
}

export function emitTrackOpenSearchAlertModalEvent(triggerLocation: SaveSearchTriggerLocation) {
  trackHotpadsEventDefinition(OPEN_SEARCH_ALERT_MODAL, { triggerLocation });
}
